module.exports = __webpack_public_path__ + "assets/img/customerHead.f68627da.png";